// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2c3Vd","file":"styles_file__2YV3p"};